module.exports = __webpack_public_path__ + "./assets/icons/facebook.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebookIcon.svg
// module id = 162
// module chunks = 0 1